$(document).ready(function () {
    //if (location.pathname == '/Support-and-Training/Client-Portal/') {

    //    var dataServicesUserType = GetSession("DataServicesUserType");
    //    var salesforceUser = GetSession("SalesforceUser");

    //    if (dataServicesUserType) {

    //        var charRegx = /^(?=.*[a-zA-Z])([a-zA-Z]+)$/;

    //        if (dataServicesUserType == 'air' && charRegx.test(dataServicesUserType)) {
    //            $(".linkDataServices").attr("href", "/Data-Services/AIR/");
    //        }
    //        else{
    //            $(".linkDataServices").attr("href", "/Data-Services/Clients/Home/");
    //        }
    //        $("#divDataServicesClient").removeClass('hide');
    //    }
    //    else {
    //        $("#divClients").removeClass('hide');
    //    }

    //    if (salesforceUser == true) {
    //        $('.caseManagementDiv').removeClass('hide');
    //    } else {
    //        $('.caseManagementDiv').remove();
    //    }

    //}

    //var contentId = $('#lblContentID').val();
    //if (typeof (GetAttachments) == 'function') {
    //    GetAttachments(contentId);
    //}
    //GetRelatedContent(contentId);

    //if (location.pathname == '/User-Management/Profile-Updated/') {
    //    setTimeout(function () {
    //        location.href = "/User-Management/Update-Registration/";
    //    }, 10000)
    //}

    //CallService("GetAccountInfoForUser", {}, true, "GetAccountInfoForUserComplete");
    //CallService("SendBlogContentNotificationTest", {}, true, "SendBlogContentNotificationTestComplete");

    if ($("#currentPageType").val() === "articles") {
        var pageData = { pageId: $("#currentPageId").val(), pageType: null };
        CallService("/api/user/GetRelatedContent", pageData, true, "GetRelatedContentComplete");
    }
    
});


function GetRelatedContentComplete(results) {    
    
    var relatedList = JSON.parse(results).ListOfRelatedItems;

    var html = '<div class="hidden-xs">';
    html += '<h3>You might also be interested in:</h3>';

    relatedList.forEach(function (item) {
        html += '<div class="blogRelatedList">';
        html += '<div class="image"><img src="' + item.Image +'"></div>';
        html += '<div class="title">';
        html += '<a href="' + item.Url +'">'+ item.Title +'</a>';
        html += '<span class="date">' + item.PublishedDate +'</span>';
        html += '</div>';
        html += '</div>';        
    })

    html += '</div>';

    $("#relatedListTemplate").html(html);
    
}

//function SendBlogContentNotificationTestComplete(result) {

//}

//function GetRelatedContent(contentId) {
//    if ($("#relatedContentContainer").length == 1) {
//        CallService("GetRelatedContent", { "contentId": contentId, "returnAll": false }, true, "GetRelatedContentComplete");
//    }
//}

//function GetRelatedContentComplete(result) {
//    if (result.GetRelatedContentResult && result.GetRelatedContentResult.length > 0) {
//        var relatedHtml = '';
//        var currentTitle;
		
//		if($("#contentHeader").html() != undefined && $("#contentHeader").html() != null && $("#contentHeader").html() != ""){
//			currentTitle = $("#contentHeader").html().trim();
//		}else{
//			currentTitle = "";
//		}
		
//        var count = 3;
//        $(result.GetRelatedContentResult).each(function (i, content) {
//            if (content.Title !== currentTitle && count > 0) {
//                relatedHtml += '<p><a href="' + content.QuickLink + '">' + content.Title + ' ››</a></p>';
//                count--;
//            }
//        });
//        $("#relatedContent").html(relatedHtml);
//        $("#relatedContentContainer").removeClass("hide");
//    }
//}

//function GetAccountInfoForUserComplete(result) {
//    if (result.GetAccountInfoForUserResult.accountIdField != null){
//        $(".caseManagement").removeClass("hide");
//    }
//}